import { render, staticRenderFns } from "./orderDispatchDialog.vue?vue&type=template&id=fc43cd5a&scoped=true"
import script from "./orderDispatchDialog.vue?vue&type=script&lang=js"
export * from "./orderDispatchDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc43cd5a",
  null
  
)

export default component.exports